var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2102 12.1598V32.6998H36.8202V12.1598C36.8202 7.54984 33.6202 3.96984 29.4002 3.96984C25.1802 3.96984 22.0402 7.54984 22.0402 12.1598V32.6998H18.5802V12.1598C18.5802 7.54984 15.3802 3.96984 11.2202 3.96984C7.06016 3.96984 3.80016 7.54984 3.80016 12.1598V32.6998H0.410156V12.1598C0.410156 11.5198 0.470161 11.0098 0.470161 11.1998L0.410156 0.769844L3.80016 0.709844L3.86016 3.52984C4.63016 2.37984 7.76016 0.589844 11.2202 0.589844C15.3802 0.589844 19.1602 3.27984 20.3102 5.83984C21.4602 3.27984 25.2402 0.589844 29.4002 0.589844C35.2902 0.589844 40.2102 5.83984 40.2102 12.1698V12.1598Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerM);
export default __webpack_public_path__ + "static/media/LOWER_M.de89ae7fc78762da59a7b897c5539bb0.svg";
export { ForwardRef as ReactComponent };